import { createFileRoute } from "@tanstack/react-router";
import { DefectGroupParentGroupView } from "src/components/views/spc/defectGroups/DefectGroupParentGroupView.tsx";
import { DefectGroupApi } from "src/api/generated/spc/defectGroups/defectGroupApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/defectGroups/$parentGroupId")({
	staticData: {
		legacyViewKey: "defectGroupParentGroupsGeneratedPages",
		listGeneratedViews: async () =>
			(await DefectGroupApi.getParentGroups()).map((parentGroup) => ({
				id: parentGroup.id,
				title: parentGroup.name,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
	} = useKeptAliveGeneratedView();
	return <DefectGroupParentGroupView parentGroupId={id} />;
}
